module.exports = __webpack_public_path__ + "80e19e9bf279ba4b868cbec11a13849a.svg";